import { createReducer } from 'lib/utilities.js';

const initialState = {
  mailchimpAccountData: undefined,
  mailchimpCampaignData: undefined,
  klaviyoAccountData: undefined,
  klaviyoCampaignData: undefined,
};

export default createReducer(initialState, {
  FETCHING_MAILCHIMP_ACCOUNT_DATA_SUCCESS: (state, payload) => {
    return {
      ...state,
      mailchimpAccountData: payload,
    };
  },
  FETCHING_MAILCHIMP_CAMPAIGNS_SUCCESS: (state, payload) => {
    return {
      ...state,
      mailchimpCampaignData: payload,
    };
  },
  FETCHING_KLAVIYO_ACCOUNT_DATA_SUCCESS: (state, payload) => {
    return {
      ...state,
      klaviyoAccountData: payload,
    };
  },
  FETCHING_KLAVIYO_CAMPAIGNS_SUCCESS: (state, payload) => {
    return {
      ...state,
      klaviyoCampaignData: payload,
    };
  },
});
